import { jwtDecode } from 'jwt-decode';
import { sdk } from 'sdk';
import { PublicConfig } from 'frontastic/hooks/useAccount/types';


export interface SSOToken {
  aud: string;
  exp: number;
}

export const fetchWithIdToken = async (url: string, method: string = 'GET', body?: any) => {
  let idToken = window.localStorage.getItem('idToken');
  const user = jwtDecode<SSOToken>(idToken || '');
  const { aud, exp } = user;
  const current = Number(new Date());
  if (exp < current / 1000) {
    const res = await sdk.callAction({ actionName: 'project/getPublicConfig' });
    if (!res.isError) {
      const cfg = res.data as PublicConfig;
      const refreshToken = window.localStorage.getItem('refreshToken');
      const response = await fetch(`${cfg.cognitoAuthUrl}/oauth/refresh`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          clientId: aud,
          idToken,
          refreshToken,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        idToken = data.idToken;
        window.localStorage.setItem('idToken', idToken || '');
        window.localStorage.setItem('refreshToken', refreshToken || '');
      }
    }
  }
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    method,
    body,
  });
};
